export default __webpack_public_path__ + "430250584f21a8b307aed08e7e198dc3.otf";